module.exports = __webpack_public_path__ + "media/application/images/2023/07_still-1450x816-dcbf7f31b2c130d087b00c05864b9e8d.png";